import React from 'react';
import { authRoles } from 'app/auth';

const ManageFaqsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/manage-faqs',
			component: React.lazy(() => import('./ManageFaqs'))
		}
	]
};

export default ManageFaqsConfig;
